import { GoogleMapProps } from '@react-google-maps/api'
import { featureCollection, intersect, polygon } from '@turf/turf'
import { Position } from 'geojson'

export const polygonColors = [
  '#9E2480',
  '#C23850',
  '#C3682A',
  '#2C8FB9',
  '#3E60C7',
  '#9551DB'
]

export const DEFAULT_CENTER = { lat: -41.2865, lng: 174.7762 }

export const NEW_ZEALAND_BOUNDS: google.maps.LatLngBoundsLiteral = {
  north: -34.36,
  south: -47.35,
  west: 166.28,
  east: -175.81
}

export const DEFAULT_MAP_PROPS: GoogleMapProps = {
  mapContainerStyle: {
    width: '100%',
    height: '100%'
  },
  options: {
    maxZoom: 20,
    mapTypeControl: true,
    streetViewControl: false,
    tiltInteractionEnabled: false,
    rotateControl: false,
    cameraControl: false,
    tilt: 0,
    mapTypeId: 'satellite'
  }
}

export const googleToTurfPolygon = (googleMapsPolygon: google.maps.Polygon) => {
  const paths = googleMapsPolygon.getPaths()
  const geoJsonCoordinates: Position[][] = []

  paths.forEach(path => {
    const linearRing: number[][] = []
    path.forEach(latLng => {
      linearRing.push([latLng.lng(), latLng.lat()])
    })
    // Close the linear ring by repeating the first coordinate
    if (linearRing.length > 0) {
      linearRing.push(linearRing[0]!)
    }
    geoJsonCoordinates.push(linearRing)
  })

  const turfPolygon = polygon(geoJsonCoordinates)
  return turfPolygon
}

export const checkIsIntersecting = (
  currentPolygonIndex: number,
  polygons: google.maps.Polygon[]
) => {
  if (!polygons[currentPolygonIndex]) return false
  if (polygons[currentPolygonIndex].getPath().getArray().length >= 4) {
    const currentPolygon = googleToTurfPolygon(polygons[currentPolygonIndex])
    const other = polygons
      .filter((p, idx) => p && idx !== currentPolygonIndex)
      .map(p => googleToTurfPolygon(p))

    if (other.length > 0) {
      const intersects = other.some(o =>
        intersect(featureCollection([o, currentPolygon]))
      )
      return intersects
    }
  }
  return false
}
